import request from '@apps-common/js-client/api/request';
import {PDA_ADMIN_V1_BASE_PATH as base} from '@account/config';

// NOTE: is_trial is intentionally NOT sent yet. The "Show trials" toggle wires
// isTrial through the hooks, but the provisioning-summary / provisions-by-product
// endpoints don't accept the param yet (marshmallow rejects unknown query args
// with a 4xx). Re-add the is_trial param here once the backend ships support.
export const getProvisioningSummary = ({start, end, granularity = 'day'}) =>
  request
    .get(`${base}/admin/reports/provisioning-summary`, {
      params: {
        start,
        end,
        granularity,
      },
    })
    .then(res => res.data);

export const getEmergencyOverrides = ({start, end, limit = 50, offset = 0}) =>
  request
    .get(`${base}/admin/reports/emergency-overrides`, {
      params: {start, end, limit, offset},
    })
    .then(res => res.data);

// Always resolves to a Blob (text/csv). Live path receives a blob directly from
// the server (no pagination) — covers the full filtered date range.
// created_by is the creating admin's email — intentional audit trail per ADR 0008 §4. Exported files contain PII.
//
// When the backend returns a 4xx/5xx, Axios wraps the JSON error body in a Blob
// because responseType:'blob' is set. We unwrap it here so callers get a real
// Error with a readable message rather than an opaque Blob.
export const getEmergencyOverridesExport = async ({start, end}) => {
  try {
    const res = await request.get(
      `${base}/admin/reports/emergency-overrides/export`,
      {params: {start, end}, responseType: 'blob'}
    );
    return res.data;
  } catch (error) {
    if (
      error.response?.data instanceof Blob &&
      error.response.data.type === 'application/json'
    ) {
      const text = await error.response.data.text();
      let parsed;
      try {
        parsed = JSON.parse(text);
      } catch {
        // JSON parse failed — fall through and re-throw original
      }
      if (parsed) {
        throw new Error(parsed.detail || parsed.message || 'Export failed');
      }
    }
    throw error;
  }
};

// is_trial intentionally omitted — see getProvisioningSummary note above.
export const getProvisionsByProduct = ({start, end, status}) =>
  request
    .get(`${base}/admin/reports/provisions-by-product`, {
      params: {
        start,
        end,
        ...(status ? {status} : {}),
      },
    })
    .then(res => res.data);
